/**
 * Helpers for tracking rows added or edited in Formik *Added arrays.
 * Channels use value.id; teams use value._id.
 */

export const getRowIdField = row => (row.value.id ? 'id' : '_id');

export const getRowId = row => row.value[getRowIdField(row)];

export const isRowAlreadyAdded = (added, row) => {
  const field = getRowIdField(row);
  const rowId = row.value[field];
  return added.some(item => item.value[field] === rowId);
};

export const upsertAddedRow = (added, row) => {
  const field = getRowIdField(row);
  const rowId = row.value[field];
  return [...added.filter(item => item.value[field] !== rowId), row];
};

export const removeAddedRow = (added, removedId, field) => {
  if (!added.find(item => item.value[field] === removedId)) {
    return added;
  }
  return added.filter(item => item.value[field] !== removedId);
};

export const clearRemovedRow = (removed, row) => {
  const rowId = getRowId(row);
  if (!removed.includes(rowId)) {
    return removed;
  }
  return removed.filter(id => id !== rowId);
};
